import { render, staticRenderFns } from "./Crud.vue?vue&type=template&id=76cd894c"
import script from "./Crud.js?vue&type=script&lang=js&external"
export * from "./Crud.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports